export class Resolucion {
  Id: string | null;
  CreatedAt: string;
  Name: string;
  Date: string;
  Url: string;
  FacultyId: string | null;
  FacultyName: string;
  IsLink: number;
  Content: string;

  File: File | null;
  FileName: string = '';

  SessionRecordId: string;

  LoadEstate: number = 0; 
  //SUBIDA  0: Pendiente, 1: Subiendo, 2: Procesando, 3: Error, 4: Procesado
  //PROCESAMIENTO 0: Pendiente, 1: Duplicado 2: Guardando, 3: Error en los registros, 4: Error en OBS, 5: Guardado

  constructor() {
    this.Id = null;
    this.CreatedAt = '';
    this.Name = '';
    this.Date = '';
    this.Url = '';
    this.FacultyId = null;
    this.FacultyName = '';
    this.IsLink = 0;
    this.Content = '';
    this.SessionRecordId = '';

    this.File = null;
    this.LoadEstate = 0;
  }
}
